'use strict';

import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Button } from 'react-bootstrap';

const Globals = require('../../../../app/globals');
import ProjectSelector from '../common/ProjectSelector';
import ErrorBox from '../common/ErrorBox';
import DistributionRestrictionWarningBox from '../common/DistributionRestrictionWarningBox';

const propTypes = {
    show: PropTypes.bool,
    buttonText: PropTypes.string,
    permissionsFunc: PropTypes.func, // function for filtering permissions. should expect params: func(userChannelPermissions, userProjectPermissions)
    error: PropTypes.object,
    headerText: PropTypes.string,
    submitHandler: PropTypes.func.isRequired,
    excludeProject: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    closeHandler: PropTypes.func.isRequired,
    distributionRestricted: PropTypes.bool,
    contentType: PropTypes.oneOf([Globals.content_type.ACTIVITY, Globals.content_type.COURSE]),
    restrictToChannelId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]), // restrict to single channel ID
};

const defaultProps = {
    show: false,
    buttonText: "ok",
    permissionsFunc: null,
    eror: null,
    headerText: 'Select Project',
    distributionRestricted: false,
    contentType: Globals.content_type.ACTIVITY,
    restrictToChannelId: "",
};

class SelectProjectModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedProject: null
        };
        this.selectProject = this.selectProject.bind(this);
        this.submitHandler = this.submitHandler.bind(this);
        this.onDistributionWarningCheck = this.onDistributionWarningCheck.bind(this);
    }

    selectProject(projectId) {
        this.setState({ selectedProject: projectId });
    }

    submitHandler() {
        this.props.submitHandler(this.state.selectedProject);
    }

    onDistributionWarningCheck(val) {
        this.setState({ warningAccepted: val });
    }

    render() {
        return (
            <Modal
                className='select-project-modal'
                show={this.props.show}
                enforceFocus={false}
                autoFocus
                backdrop={false}
                animation={false}
                keyboard
                onHide={this.props.closeHandler}
            >
                <Modal.Header closeButton onHide={this.props.closeHandler}>
                    <Modal.Title>{this.props.headerText}</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <ErrorBox error={this.props.error} />
                    {(this.props.distributionRestricted) &&
                        <DistributionRestrictionWarningBox className="font-size-md" onChangeAcceptance={this.onDistributionWarningCheck} />
                    }
                    <ProjectSelector
                        label="Select a destination project:"
                        selectedProject={this.state.selectedProject}
                        onSelect={this.selectProject}
                        excludeProject={this.props.excludeProject}
                        permissionsFunc={this.props.permissionsFunc}
                        contentType={this.props.contentType}
                        restrictToChannelId={this.props.restrictToChannelId}
                    />
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        disabled={!this.state.selectedProject
                            || (this.props.distributionRestricted && !this.state.warningAccepted)
                        }
                        onClick={this.submitHandler}
                    >
                        {this.props.buttonText}
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }
}

export default SelectProjectModal;
